import { render, staticRenderFns } from "./CampaignPaymentList.vue?vue&type=template&id=2cabeb98&scoped=true&"
import script from "./CampaignPaymentList.vue?vue&type=script&lang=js&"
export * from "./CampaignPaymentList.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPaymentList.vue?vue&type=style&index=0&id=2cabeb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cabeb98",
  null
  
)

export default component.exports